import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className="footer">
            <p className="footer__text">
                کلیه حقوق این سایت متعلق به ایرانکازمتیکو می‌باشد
                <span className="footer__heart">❤</span>
                ساخته شده با عشق توسط تیم دکتر سیمین
            </p>
        </div>
    );
}

export default Footer;
